// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TbJYUkuORm_UIq11uFawm","video":"_3HDXk1kOP_b0GYqWUeXXFB"};